// DivaCase Shopify Theme - Main App Logic (Shopify AJAX Cart Edition)

// Format currency in Turkish Lira style
function escapeHTML(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `${Number(amount).toLocaleString("tr-TR")} TL`;
}

// Global Cart State update
window.updateCartDOM = function() {
    fetch('/cart.js')
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(cart => {
            const cartCount = document.getElementById('cart-count');
            const cartItems = document.getElementById('cart-items');
            const cartTotal = document.getElementById('cart-total');
            const cartEmpty = document.getElementById('cart-empty');
            
            // Update count in header
            if (cartCount) cartCount.textContent = cart.item_count;
            
            // Free Shipping Threshold (Default to 400 TL if not provided by theme settings)
            const threshold = window.themeSettings?.freeShippingThreshold || 400;
            const subtotalInTL = cart.total_price / 100;
            
            // iOS Style Shipping Progress Bar
            const remainingText = document.getElementById('shipping-text');
            const barFill = document.getElementById('shipping-bar-fill');
            const shippingProgressContainer = document.getElementById('cart-shipping-progress');
            
            if (shippingProgressContainer) {
                if (cart.item_count === 0) {
                    shippingProgressContainer.style.display = 'none';
                } else {
                    shippingProgressContainer.style.display = 'block';
                    if (remainingText && barFill) {
                        if (subtotalInTL >= threshold) {
                            remainingText.innerHTML = '<span style="color:var(--success); font-weight:600;">Kargonuz Ücretsiz!</span>';
                            barFill.style.width = '100%';
                            barFill.classList.remove('warning');
                        } else {
                            const left = threshold - subtotalInTL;
                            remainingText.innerHTML = `Ücretsiz kargoya <span id="shipping-remaining" style="font-weight:600;">${left.toFixed(2)} TL</span> kaldı`;
                            barFill.style.width = `${Math.min(100, (subtotalInTL / threshold) * 100)}%`;
                            barFill.classList.add('warning');
                        }
                    }
                }
            }

            // Render items in Drawer
            const drawerCheckoutBtn = document.querySelector('.cart-drawer button[name="checkout"]');
            if (cartItems) {
                if (cart.item_count === 0) {
                    cartItems.innerHTML = '';
                    if (cartEmpty) cartEmpty.hidden = false;
                    else cartItems.innerHTML = '<div class="cart-empty-state" style="padding:40px; text-align:center; color:var(--text-slate);">Sepetiniz boş.</div>';
                    
                    if (cartTotal) cartTotal.textContent = '0 TL';
                    if (drawerCheckoutBtn) drawerCheckoutBtn.disabled = true;
                } else {
                    if (cartEmpty) cartEmpty.hidden = true;
                    if (drawerCheckoutBtn) drawerCheckoutBtn.disabled = false;
                    cartItems.innerHTML = '';
                    
                    cart.items.forEach((item, index) => {
                        const itemEl = document.createElement('div');
                        itemEl.className = 'cart-item';
                        
                        // Extract properties if any
                        let propertiesHtml = '';
                        if (item.properties && Object.keys(item.properties).length > 0) {
                            propertiesHtml = '<div class="cart-item-properties" style="font-size: 11px; margin-top: 4px; color: var(--accent-cobalt); font-weight:500;">';
                            for (const [key, value] of Object.entries(item.properties)) {
                                if (value) {
                                    propertiesHtml += `<div><strong>${escapeHTML(key)}:</strong> ${escapeHTML(value)}</div>`;
                                }
                            }
                            propertiesHtml += '</div>';
                        }

                        const currentPrice = item.price;
                        const actualCompare = window.themeVariantComparePrices?.[item.variant_id] || item.compare_at_price || 0;
                        const originalPrice = (actualCompare > currentPrice) ? actualCompare : Math.ceil(currentPrice * 1.18);
                        const comparePriceHtml = originalPrice > currentPrice ? `<span class="compare-price" style="text-decoration:line-through; font-size:11px; color:var(--text-muted); margin-right:6px;">${formatMoney(originalPrice)}</span>` : '';
                        
                        itemEl.innerHTML = `
                            <div class="cart-item-img">
                                <img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" style="max-height: 80%; border-radius: 8px;">
                            </div>
                            <div class="cart-item-info" style="flex:1;">
                                <div class="cart-item-title font-display" style="font-weight:600; font-size:14px;">${escapeHTML(item.product_title)}</div>
                                <div class="cart-item-meta text-secondary" style="font-size:12px; margin-top:2px;">${escapeHTML(item.variant_title || '')}</div>
                                ${propertiesHtml}
                                <div class="cart-item-bottom" style="margin-top: 10px; display:flex; justify-content:space-between; align-items:center;">
                                    <div class="drawer-qty-control" style="display:inline-flex; align-items:center; border:1px solid var(--border-focus); border-radius:50px; overflow:hidden; background:#fff;">
                                        <button type="button" onclick="updateCartQty(${index + 1}, ${item.quantity - 1})" style="padding:3px 10px; font-weight:600; font-size:12px; cursor:pointer; background:none; border:none; color:var(--text-obsidian);">-</button>
                                        <span style="font-weight:700; font-size:11px; width:20px; text-align:center;">${item.quantity}</span>
                                        <button type="button" onclick="updateCartQty(${index + 1}, ${item.quantity + 1})" style="padding:3px 10px; font-weight:600; font-size:12px; cursor:pointer; background:none; border:none; color:var(--text-obsidian);">+</button>
                                    </div>
                                    <div class="cart-item-price" style="font-weight:700; color:var(--text-obsidian); font-size:13px;">
                                        ${comparePriceHtml}
                                        <span>${formatMoney(currentPrice)}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                        cartItems.appendChild(itemEl);
                    });
                    
                    let totalOriginalPrice = 0;
                    cart.items.forEach(item => {
                        const actualCompare = window.themeVariantComparePrices?.[item.variant_id] || item.compare_at_price || 0;
                        const origPrice = (actualCompare > item.price) ? actualCompare : Math.ceil(item.price * 1.18);
                        totalOriginalPrice += origPrice * item.quantity;
                    });
                    
                    if (cartTotal) {
                        if (totalOriginalPrice > cart.total_price) {
                            cartTotal.innerHTML = `<span class="compare-price" style="text-decoration:line-through; font-size:14px; color:var(--text-muted); margin-right:8px; font-weight:500;">${formatMoney(totalOriginalPrice)}</span><span>${formatMoney(cart.total_price)}</span>`;
                        } else {
                            cartTotal.textContent = formatMoney(cart.total_price);
                        }
                    }
                }
            }

            // Render Full Cart Page elements if they exist on standalone cart page
            renderFullCartPage(cart);
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
};

// Bind manual quantity inputs change listener
function handleCartQtyInputChange(e) {
    const input = e.target;
    const lineIndex = parseInt(input.dataset.lineIndex, 10);
    let newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 0) {
        newQty = 1;
        input.value = 1;
    }
    if (!isNaN(lineIndex)) {
        window.updateCartQty(lineIndex, newQty);
    }
}

function bindCartQtyInputs() {
    document.querySelectorAll('.cart-qty-input').forEach(input => {
        input.removeEventListener('change', handleCartQtyInputChange);
        input.addEventListener('change', handleCartQtyInputChange);
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                input.blur();
            }
        });
    });
}

// Standalone Cart Page renderer
function renderFullCartPage(cart) {
    const fullCartItems = document.getElementById('full-cart-items');
    const fullSubtotal = document.getElementById('full-cart-subtotal');
    const fullTotal = document.getElementById('full-cart-total');
    
    if (!fullCartItems) return;
    
    // Update Cart Page shipping progress bar if present
    const threshold = window.themeSettings?.freeShippingThreshold || 400;
    const subtotalInTL = cart.total_price / 100;
    const pageRemainingText = document.getElementById('page-shipping-text');
    const pageBarFill = document.getElementById('page-shipping-bar-fill');
    const pageProgressCard = document.getElementById('page-shipping-progress-card');
    const checkoutBtn = document.querySelector('button[name="checkout"]');
    
    if (pageProgressCard) {
        if (cart.item_count === 0) {
            pageProgressCard.style.display = 'none';
        } else {
            pageProgressCard.style.display = 'block';
            if (pageRemainingText && pageBarFill) {
                if (subtotalInTL >= threshold) {
                    pageRemainingText.innerHTML = '<span style="color:var(--success, #10B981); font-weight:700;">Tebrikler! Ücretsiz kargo kazandınız.</span>';
                    pageBarFill.style.width = '100%';
                } else {
                    const left = threshold - subtotalInTL;
                    pageRemainingText.innerHTML = `Ücretsiz kargoya <span style="font-weight:700; color:var(--accent-cobalt, #007aff);">${formatMoney(left * 100)}</span> kaldı`;
                    pageBarFill.style.width = `${Math.min(100, (subtotalInTL / threshold) * 100)}%`;
                }
            }
        }
    }
    
    if (checkoutBtn) {
        checkoutBtn.disabled = (cart.item_count === 0);
    }
    
    if (cart.item_count === 0) {
        fullCartItems.innerHTML = '<div style="padding:40px 0; color:var(--text-slate); font-size:18px;">Sepetiniz şu an boş. <br><br><a href="/collections/all" class="btn btn-primary" style="display:inline-flex; margin-top:24px;">Alışverişe Başla</a></div>';
        if (fullSubtotal) fullSubtotal.textContent = '0 TL';
        if (fullTotal) fullTotal.textContent = '0 TL';
        return;
    }
    
    let html = '';
    cart.items.forEach((item, index) => {
        // Properties mapping
        let propertiesHtml = '';
        if (item.properties && Object.keys(item.properties).length > 0) {
            propertiesHtml = '<div class="cart-page-item-properties" style="font-size: 12px; margin-top: 4px; color: var(--accent-cobalt);">';
            for (const [key, value] of Object.entries(item.properties)) {
                if (value) {
                    propertiesHtml += `<div><strong>${escapeHTML(key)}:</strong> ${escapeHTML(value)}</div>`;
                }
            }
            propertiesHtml += '</div>';
        }

        const currentPrice = item.price;
        const actualCompare = window.themeVariantComparePrices?.[item.variant_id] || item.compare_at_price || 0;
        const originalPrice = (actualCompare > currentPrice) ? actualCompare : Math.ceil(currentPrice * 1.18);
        const comparePriceHtml = originalPrice > currentPrice ? `<span class="compare-price" style="text-decoration:line-through; font-size:12px; color:var(--text-muted); margin-right:8px;">${formatMoney(originalPrice)}</span>` : '';

        html += `
        <div class="cart-page-item" style="display: flex; gap: 20px; padding: 24px 0; border-bottom: 1.5px solid rgba(0,0,0,0.06); box-sizing: border-box; width: 100%; min-width: 0;">
            <div class="cart-page-img" style="flex-shrink:0;">
                <img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}">
            </div>
            <div class="cart-page-info" style="flex:1; min-width: 0;">
                <div style="display:flex; justify-content:space-between; align-items:flex-start; width:100%; min-width:0; gap:12px;">
                    <div class="cart-page-item-title" style="font-size:16px; font-weight:700; flex:1; min-width:0; word-break:break-word;">${escapeHTML(item.product_title)}</div>
                    <button type="button" class="text-secondary" style="font-size:13px; text-decoration:underline; cursor:pointer; border:none; background:transparent; flex-shrink:0; color:#777;" onclick="removeFromCart(${index + 1})">Kaldır</button>
                </div>
                <div class="cart-page-item-meta text-secondary" style="font-size:13px; margin-top:4px;">${escapeHTML(item.variant_title || '')}</div>
                ${propertiesHtml}
                <div class="cart-page-item-qty-price" style="display:flex; justify-content:space-between; align-items:center; margin-top:12px;">
                    <div class="cart-qty-control" style="display:inline-flex; align-items:center; border:1px solid var(--border-focus); border-radius:50px; overflow:hidden; background:#fff;">
                        <button type="button" onclick="updateCartQty(${index + 1}, ${item.quantity - 1})" style="padding:6px 14px; font-weight:600; font-size:14px; cursor:pointer; background:none; border:none; color:var(--text-obsidian);">-</button>
                        <input type="number" name="updates[${item.key}]" id="updates_${item.key}" class="cart-qty-input" data-line-index="${index + 1}" value="${item.quantity}" min="0" style="width:40px; text-align:center; border:none; background:none; font-weight:700; font-size:13px; outline:none;">
                        <button type="button" onclick="updateCartQty(${index + 1}, ${item.quantity + 1})" style="padding:6px 14px; font-weight:600; font-size:14px; cursor:pointer; background:none; border:none; color:var(--text-obsidian);">+</button>
                    </div>
                    <div class="cart-page-item-price" style="display:flex; align-items:center;">
                        ${comparePriceHtml}
                        <span class="current-price" style="font-weight:800; color:var(--text-obsidian); font-size:15px;">${formatMoney(currentPrice)}</span>
                    </div>
                </div>
            </div>
        </div>
        `;
    });
    
    let totalOriginalPrice = 0;
    cart.items.forEach(item => {
        const actualCompare = window.themeVariantComparePrices?.[item.variant_id] || item.compare_at_price || 0;
        const origPrice = (actualCompare > item.price) ? actualCompare : Math.ceil(item.price * 1.18);
        totalOriginalPrice += origPrice * item.quantity;
    });

    fullCartItems.innerHTML = html;
    
    // Dynamically update receipt items list in sidebar if present
    const receiptItemsList = document.getElementById('receipt-items-list');
    if (receiptItemsList) {
        let receiptHtml = '';
        cart.items.forEach(item => {
            const priceVal = formatMoney(item.price * item.quantity);
            const vTitle = item.variant_title ? ` (${item.variant_title})` : '';
            receiptHtml += `
                <div style="display:flex; justify-content:space-between; font-family: monospace, Courier, monospace; font-size: 11px; margin-bottom: 6px; color: #222; line-height:1.4; gap: 8px;">
                    <div style="flex:1; padding-right:10px; word-break:break-word;">
                        ${item.quantity}x ${escapeHTML(item.product_title)}${escapeHTML(vTitle)}
                    </div>
                    <div style="font-weight:700; flex-shrink:0;">${priceVal}</div>
                </div>
            `;
        });
        receiptItemsList.innerHTML = receiptHtml;
    }

    if (fullSubtotal) {
        if (totalOriginalPrice > cart.total_price) {
            fullSubtotal.innerHTML = `<span class="compare-price" style="text-decoration:line-through; font-size:13px; color:var(--text-muted); margin-right:8px; font-weight:500;">${formatMoney(totalOriginalPrice)}</span><span>${formatMoney(cart.total_price)}</span>`;
        } else {
            fullSubtotal.textContent = formatMoney(cart.total_price);
        }
    }
    if (fullTotal) {
        if (totalOriginalPrice > cart.total_price) {
            fullTotal.innerHTML = `<span class="compare-price" style="text-decoration:line-through; font-size:15px; color:var(--text-muted); margin-right:8px; font-weight:500;">${formatMoney(totalOriginalPrice)}</span><span>${formatMoney(cart.total_price)}</span>`;
        } else {
            fullTotal.textContent = formatMoney(cart.total_price);
        }
    }
    bindCartQtyInputs();
}

// AJAX Remove from cart
window.removeFromCart = function(lineIndex) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: 0 })
    })
    .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    })
    .then(() => {
        window.updateCartDOM();
    })
    .catch(error => {
        console.error('Error removing item:', error);
    });
};

// AJAX Update quantity
window.updateCartQty = function(lineIndex, newQuantity) {
    if (newQuantity < 0) return;
    if (newQuantity === 0) {
        window.removeFromCart(lineIndex);
        return;
    }
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: newQuantity })
    })
    .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    })
    .then(() => {
        window.updateCartDOM();
    })
    .catch(error => {
        console.error('Error updating quantity:', error);
    });
};

// AJAX Add to Cart
window.addToCart = function(variantId, quantity = 1, properties = {}) {
    let hasFile = false;
    if (properties) {
        for (const val of Object.values(properties)) {
            if (val instanceof File) {
                hasFile = true;
                break;
            }
        }
    }

    if (hasFile) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        for (const [key, val] of Object.entries(properties)) {
            formData.append(`properties[${key}]`, val);
        }

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(() => {
            window.updateCartDOM();
            window.toggleCart(true); // Open drawer
        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
            alert('Bu ürün sepete eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
        });
        return;
    }

    const payload = {
        id: variantId,
        quantity: quantity
    };
    if (properties && Object.keys(properties).length > 0) {
        payload.properties = properties;
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
    .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    })
    .then(() => {
        window.updateCartDOM();
        window.toggleCart(true); // Open drawer
    })
    .catch(error => {
        console.error('Error adding item to cart:', error);
        alert('Bu ürün sepete eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
    });
};

// Drawer toggles
window.toggleCart = function(forceOpen = false) {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if(!drawer || !overlay) return;
    
    if (forceOpen === true || !drawer.classList.contains('active')) {
        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    } else {
        drawer.classList.remove('active');
        overlay.classList.remove('active');
        document.body.style.overflow = '';
    }
};

// Drawer Upsell Click action
window.addUpsell = function(event) {
    const btn = event.target;
    const variantId = btn.dataset.upsellVariantId;
    if (!variantId) return;

    const originalText = btn.innerHTML;
    btn.innerHTML = 'Eklendi';
    btn.style.backgroundColor = 'var(--success)';
    btn.style.color = '#fff';
    
    window.addToCart(variantId, 1);
    
    setTimeout(() => {
        btn.innerHTML = originalText;
        btn.style.backgroundColor = '';
        btn.style.color = '';
    }, 2000);
};

// Universal brand detector based on model name
window.detectBrandFromModel = function(model) {
    if (!model) return 'Diğer';
    const m = model.toLowerCase();
    if (m.includes('iphone') || m.includes('apple') || m.includes('se') || m.includes('ipad') || m.includes('macbook')) {
        return 'Apple';
    }
    if (m.includes('galaxy') || m.includes('samsung') || m.includes('note') || m.includes('ultra') || m.includes('fold') || m.includes('flip') || /^(s\d|a\d|m\d|sm-|z\s*fold|z\s*flip)/i.test(m)) {
        return 'Samsung';
    }
    if (m.includes('pixel') || m.includes('google')) {
        return 'Google';
    }
    if (m.includes('xiaomi') || m.includes('redmi') || m.includes('poco') || m.includes('mi ')) {
        return 'Xiaomi';
    }
    if (m.includes('huawei') || m.includes('mate') || m.includes('nova')) {
        return 'Huawei';
    }
    if (m.includes('oneplus')) {
        return 'OnePlus';
    }
    if (m.includes('oppo') || m.includes('reno')) {
        return 'Oppo';
    }
    if (m.includes('realme')) {
        return 'Realme';
    }
    if (m.includes('nothing')) {
        return 'Nothing';
    }
    // Extract first word as brand name if it has spaces
    const words = model.trim().split(/\s+/);
    if (words.length > 1) {
        const firstWord = words[0];
        if (firstWord.length > 2 && /^[A-Za-z]+$/.test(firstWord)) {
            return firstWord.charAt(0).toUpperCase() + firstWord.slice(1).toLowerCase();
        }
    }
    return 'Diğer';
};

// Quick Buy option resolver for product grids
window.quickAddToCart = function(btnEl, prodId) {
    const cardEl = btnEl.closest('.minimal-card');
    if (!cardEl) return;
    
    // Get chosen variants from dropdowns
    const brandSelect = cardEl.querySelector('.quick-brand-select');
    const modelSelect = cardEl.querySelector('.quick-model-select');
    if (!brandSelect || !modelSelect) return;
    
    const selectedBrand = brandSelect.value;
    const selectedModel = modelSelect.value;
    
    // Read the products data loaded as JSON in window
    const productsData = window.themeProductsData || [];
    const prod = productsData.find(p => String(p.id) === String(prodId));
    if (!prod) return;
    
    let modelOptIndex = -1;
    let colorOptIndex = -1;
    let brandOptIndex = -1;
    
    prod.options.forEach((opt, idx) => {
        const oLower = opt.toLowerCase();
        if (oLower.includes('renk') || oLower.includes('color') || oLower.includes('desen') || oLower.includes('colour') || oLower.includes('finish')) {
            colorOptIndex = idx;
        } else if (oLower.includes('model') || oLower.includes('cihaz') || oLower.includes('device') || oLower.includes('telefon') || oLower.includes('size') || oLower.includes('beden')) {
            modelOptIndex = idx;
        } else if (oLower.includes('marka') || oLower.includes('brand')) {
            brandOptIndex = idx;
        }
    });
    
    if (modelOptIndex === -1 && colorOptIndex === -1 && brandOptIndex === -1) {
        if (prod.options.length >= 2) {
            modelOptIndex = 0;
            colorOptIndex = 1;
        } else {
            modelOptIndex = 0;
        }
    } else {
        const indices = Array.from({ length: prod.options.length }, (_, i) => i);
        const mappedIndices = [brandOptIndex, modelOptIndex, colorOptIndex];
        indices.forEach(idx => {
            if (!mappedIndices.includes(idx)) {
                if (modelOptIndex === -1) modelOptIndex = idx;
                else if (colorOptIndex === -1 && !prod.options[idx].toLowerCase().includes('marka')) colorOptIndex = idx;
                else if (brandOptIndex === -1) brandOptIndex = idx;
            }
        });
    }
    
    const modelKey = modelOptIndex >= 0 ? `option${modelOptIndex + 1}` : 'option1';
    const colorKey = colorOptIndex >= 0 ? `option${colorOptIndex + 1}` : null;
    const brandKey = brandOptIndex >= 0 ? `option${brandOptIndex + 1}` : null;
    
    let initialColor = '';
    if (colorKey) {
        const possibleVar = prod.variants.find(v => v[modelKey] === selectedModel);
        if (possibleVar) {
            initialColor = possibleVar[colorKey];
        }
    }
    
    const matchingVariant = prod.variants.find(v => {
        let matches = true;
        if (v[modelKey] !== selectedModel) matches = false;
        if (colorKey && v[colorKey] !== initialColor) matches = false;
        if (brandKey) {
            const vBrand = v[brandKey] || "";
            if (vBrand !== selectedBrand) matches = false;
        } else {
            const modelValue = v[modelKey];
            const detectedBrand = window.detectBrandFromModel(modelValue);
            if (detectedBrand !== selectedBrand) matches = false;
        }
        return matches;
    });

    if (matchingVariant) {
        window.addToCart(matchingVariant.id, 1);
    } else {
        // Fallback to first available variant
        window.addToCart(prod.variants[0].id, 1);
    }
};

// Brand change updater for quick buy grids
window.handleCardBrandChange = function(selectEl, prodId) {
    const card = selectEl.closest('.minimal-card');
    if (!card) return;
    const modelSelect = card.querySelector('.quick-model-select');
    if (!modelSelect) return;
    
    const productsData = window.themeProductsData || [];
    const prod = productsData.find(p => String(p.id) === String(prodId));
    if (!prod) return;
    
    const selectedBrand = selectEl.value;
    
    let modelOptIndex = -1;
    prod.options.forEach((opt, idx) => {
        const oLower = opt.toLowerCase();
        if (oLower.includes('model') || oLower.includes('cihaz') || oLower.includes('device') || oLower.includes('telefon') || oLower.includes('size') || oLower.includes('beden')) {
            modelOptIndex = idx;
        }
    });
    if (modelOptIndex === -1) {
        modelOptIndex = prod.options.findIndex(opt => !opt.toLowerCase().includes('marka') && !opt.toLowerCase().includes('brand'));
        if (modelOptIndex === -1) modelOptIndex = 0;
    }
    
    const modelKey = `option${modelOptIndex + 1}`;
    let brandOptIndex = prod.options.findIndex(opt => opt.toLowerCase().includes('marka') || opt.toLowerCase().includes('brand'));
    const brandKey = brandOptIndex >= 0 ? `option${brandOptIndex + 1}` : null;
    
    const brandModels = [];
    prod.variants.forEach(variant => {
        const modelValue = variant[modelKey];
        if (modelValue) {
            let detectedBrand = 'Diğer';
            if (brandKey && variant[brandKey]) {
                detectedBrand = variant[brandKey];
            } else {
                detectedBrand = window.detectBrandFromModel(modelValue);
            }
            
            if (detectedBrand === selectedBrand && !brandModels.includes(modelValue)) {
                brandModels.push(modelValue);
            }
        }
    });

    brandModels.sort();
    
    if (brandModels.length === 0) {
        const allModels = [...new Set(prod.variants.map(v => v[modelKey]).filter(Boolean))];
        modelSelect.innerHTML = allModels.map(m => `<option value="${m}">${m}</option>`).join('');
    } else {
        modelSelect.innerHTML = brandModels.map(m => `<option value="${m}">${m}</option>`).join('');
    }
    
    window.updateCardPrice(card, prod, selectedBrand, modelSelect.value);
};

// Model change updater for quick buy grids
window.handleCardModelChange = function(selectEl, prodId) {
    const card = selectEl.closest('.minimal-card');
    if (!card) return;
    const brandSelect = card.querySelector('.quick-brand-select');
    if (!brandSelect) return;
    
    const productsData = window.themeProductsData || [];
    const prod = productsData.find(p => String(p.id) === String(prodId));
    if (!prod) return;
    
    window.updateCardPrice(card, prod, brandSelect.value, selectEl.value);
};

// Card price sync helper
window.updateCardPrice = function(card, prod, selectedBrand, selectedModel) {
    let modelOptIndex = -1;
    let brandOptIndex = -1;
    prod.options.forEach((opt, idx) => {
        const oLower = opt.toLowerCase();
        if (oLower.includes('model') || oLower.includes('cihaz') || oLower.includes('device') || oLower.includes('telefon') || oLower.includes('size') || oLower.includes('beden')) {
            modelOptIndex = idx;
        } else if (oLower.includes('marka') || oLower.includes('brand')) {
            brandOptIndex = idx;
        }
    });
    if (modelOptIndex === -1) modelOptIndex = 0;
    const modelKey = `option${modelOptIndex + 1}`;
    const brandKey = brandOptIndex >= 0 ? `option${brandOptIndex + 1}` : null;

    const currentVar = prod.variants.find(v => {
        let matches = true;
        if (v[modelKey] !== selectedModel) matches = false;
        if (brandKey && v[brandKey] !== selectedBrand) matches = false;
        if (!brandKey && window.detectBrandFromModel(v[modelKey]) !== selectedBrand) matches = false;
        return matches;
    }) || prod.variants[0];

    if (currentVar) {
        const currentPriceEl = card.querySelector('.current-price');
        const comparePriceEl = card.querySelector('.compare-price');
        if (currentPriceEl) {
            currentPriceEl.textContent = formatMoney(currentVar.price);
        }
        const actualCompare = currentVar.compare_at_price || 0;
        const compPrice = (actualCompare > currentVar.price) ? actualCompare : Math.ceil(currentVar.price * 1.18);
        if (comparePriceEl) {
            if (compPrice > currentVar.price) {
                comparePriceEl.textContent = formatMoney(compPrice);
                comparePriceEl.style.display = 'inline';
            } else {
                comparePriceEl.style.display = 'none';
            }
        }
    }
};

// Animation and Countdown Logic
document.addEventListener('DOMContentLoaded', () => {
    // Initial load of cart
    window.updateCartDOM();
    if (typeof bindCartQtyInputs === 'function') {
        bindCartQtyInputs();
    }

    // Scroll Reveal Intersection Observer
    const reveals = document.querySelectorAll('.reveal');
    const revealOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    window.revealOnScroll = new IntersectionObserver(function(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                observer.unobserve(entry.target);
            }
        });
    }, revealOptions);

    reveals.forEach(reveal => {
        window.revealOnScroll.observe(reveal);
    });

    // Timers Logic (Campaign Promo End Timer)
    let promoEndTime = localStorage.getItem('kilif_timer_promo');
    if (!promoEndTime || new Date().getTime() > promoEndTime) {
        // Default: 2 hours 45 mins 30 secs from first load
        promoEndTime = new Date().getTime() + (2 * 3600 + 45 * 60 + 30) * 1000;
        localStorage.setItem('kilif_timer_promo', promoEndTime);
    }

    function updateTimers() {
        const now = new Date().getTime();
        const promoDist = promoEndTime - now;
        
        if (promoDist > 0) {
            const h = Math.floor((promoDist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const m = Math.floor((promoDist % (1000 * 60 * 60)) / (1000 * 60));
            const s = Math.floor((promoDist % (1000 * 60)) / 1000);
            
            const promoUnits = document.querySelectorAll('#promo-timer .timer-unit');
            if(promoUnits.length === 3) {
                promoUnits[0].textContent = String(h).padStart(2, '0');
                promoUnits[1].textContent = String(m).padStart(2, '0');
                promoUnits[2].textContent = String(s).padStart(2, '0');
            }

            const pdpTimer = document.getElementById('pdp-countdown');
            if (pdpTimer) {
                pdpTimer.textContent = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
            }
        }
    }
    
    setInterval(updateTimers, 1000);
    updateTimers();

    // Live Activity Ticker (Social Proof Popup)
    const buyersRaw = window.themeSettings?.socialProofBuyers || "";
    const productsRaw = window.themeSettings?.socialProofProducts || "";
    const colorsRaw = window.themeSettings?.socialProofColors || "";
    
    const buyers = buyersRaw.split(',').map(s => s.trim()).filter(Boolean);
    const products = productsRaw.split(',').map(s => s.trim()).filter(Boolean);
    const activeColorNames = colorsRaw.split(',').map(s => s.trim()).filter(Boolean);
    
    const defaultBuyers = ["Ahmet (İstanbul)", "Mehmet (Ankara)", "Can (İzmir)", "Efe (Bursa)", "Burak (Antalya)", "Yiğit (Kocaeli)", "Selin (Muğla)", "Elif (Adana)", "Demet (Ankara)", "Kaan (İstanbul)"];
    const defaultProducts = ["Aero MagSafe", "Lumen Clear", "Terra Grip", "Mono Text", "Edge Armor", "Soft Loop", "Clear Ring", "Poster Case"];
    const defaultColors = ["Graphite", "Moss", "Clay", "Ice", "Smoke", "Rose", "Forest", "Ivory", "Lilac", "Sage", "Sand", "Crystal"];
    
    const activeBuyers = buyers.length > 0 ? buyers : defaultBuyers;
    const activeProducts = products.length > 0 ? products : defaultProducts;
    const activeColors = activeColorNames.length > 0 ? activeColorNames : defaultColors;
    
    const intervalMs = (window.themeSettings?.socialProofInterval || 22) * 1000;
    const durationMs = (window.themeSettings?.socialProofDuration || 6) * 1000;
    const activeDurationMs = Math.max(1000, Math.min(durationMs, intervalMs - 1000));
    
    function showActivity() {
        let ticker = document.getElementById("live-activity-ticker");
        if (!ticker) {
            ticker = document.createElement("div");
            ticker.id = "live-activity-ticker";
            ticker.style = "position:fixed; bottom:24px; left:24px; background:rgba(255,255,255,0.9); backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); border:1px solid rgba(0,0,0,0.08); padding:16px 20px; border-radius:16px; box-shadow:0 20px 40px rgba(0,0,0,0.08); display:flex; align-items:center; gap:12px; z-index:9999; transform:translateY(100px); opacity:0; transition:all 0.6s cubic-bezier(0.16, 1, 0.3, 1); max-width:320px;";
            document.body.appendChild(ticker);
        }
        
        const buyer = activeBuyers[Math.floor(Math.random() * activeBuyers.length)];
        const prodName = activeProducts[Math.floor(Math.random() * activeProducts.length)];
        const color = activeColors[Math.floor(Math.random() * activeColors.length)];
        
        ticker.innerHTML = `
            <div style="width:10px; height:10px; background:#10B981; border-radius:50%; box-shadow:0 0 0 4px rgba(16,185,129,0.2); flex-shrink:0;"></div>
            <div style="font-size:13px; color:var(--text-obsidian); line-height:1.4;">
                <strong>${escapeHTML(buyer)}</strong> az önce bir <strong>${escapeHTML(prodName)}</strong> siparişi verdi.
                <div style="font-size:11px; color:var(--text-slate); margin-top:2px;">1 dakika önce - Doğrulanmış Sipariş</div>
            </div>
        `;
        
        // Slide in
        setTimeout(() => {
            ticker.style.transform = "translateY(0)";
            ticker.style.opacity = "1";
        }, 100);
        
        // Slide out
        setTimeout(() => {
            ticker.style.transform = "translateY(100px)";
            ticker.style.opacity = "0";
        }, activeDurationMs);
    }
    
    // Social Proof Activity loop (only starts if enabled in settings)
    if (window.themeSettings?.socialProofEnabled) {
        setTimeout(() => {
            showActivity();
            setInterval(showActivity, intervalMs);
        }, 4000);
    }
});

// Dynamic Quick Buy Options Modal Operations
window.openQuickBuyModal = function(prodId) {
    const productsData = window.themeProductsData || [];
    const prod = productsData.find(p => String(p.id) === String(prodId));
    if (!prod) return;
    
    // Select modal elements
    const overlay = document.getElementById('quick-buy-overlay');
    const modal = document.getElementById('quick-buy-modal');
    const titleEl = document.getElementById('quick-buy-title');
    const typeEl = document.getElementById('quick-buy-type');
    const imageEl = document.getElementById('quick-buy-image');
    const brandContainer = document.getElementById('quick-buy-brand-chips');
    const modelContainer = document.getElementById('quick-buy-model-chips');
    const priceEl = document.getElementById('quick-buy-price');
    const submitBtn = document.getElementById('quick-buy-submit-btn');
    
    if (!overlay || !modal) return;
    
    // Set title and type
    if (titleEl) titleEl.textContent = prod.title || "Ürün";
    if (typeEl) typeEl.textContent = prod.type || "Kılıf";
    
    // Try to find the image from the card
    const cardImg = document.querySelector(`.minimal-card[data-prod-id="${prodId}"] .minimal-image img`);
    if (imageEl && cardImg) {
        imageEl.src = cardImg.src;
        imageEl.alt = cardImg.alt || prod.title;
    }
    
    // Find unique brands and models
    let modelOptIndex = -1;
    let brandOptIndex = -1;
    prod.options.forEach((opt, idx) => {
        const oLower = opt.toLowerCase();
        if (oLower.includes('model') || oLower.includes('cihaz') || oLower.includes('device') || oLower.includes('telefon') || oLower.includes('size') || oLower.includes('beden')) {
            modelOptIndex = idx;
        } else if (oLower.includes('marka') || oLower.includes('brand')) {
            brandOptIndex = idx;
        }
    });
    if (modelOptIndex === -1) modelOptIndex = 0;
    
    const modelKey = `option${modelOptIndex + 1}`;
    const brandKey = brandOptIndex >= 0 ? `option${brandOptIndex + 1}` : null;
    
    // Collect unique brands
    const brands = [];
    prod.variants.forEach(v => {
        let bVal = 'Diğer';
        if (brandKey && v[brandKey]) {
            bVal = v[brandKey];
        } else {
            const mVal = v[modelKey] || "";
            bVal = window.detectBrandFromModel(mVal);
        }
        if (bVal && !brands.includes(bVal)) {
            brands.push(bVal);
        }
    });
    
    let selectedBrand = brands[0] || 'Diğer';
    let selectedModel = '';

    // Render Brand Chips
    if (brandContainer) {
        brandContainer.innerHTML = brands.map((b, idx) => {
            const isActive = b === selectedBrand;
            return `<div class="quick-buy-chip ${isActive ? 'active' : ''}" data-brand="${escapeHTML(b)}">${escapeHTML(b)}</div>`;
        }).join('');

        // Attach click listeners
        brandContainer.querySelectorAll('.quick-buy-chip').forEach(chip => {
            chip.addEventListener('click', (e) => {
                brandContainer.querySelectorAll('.quick-buy-chip').forEach(c => c.classList.remove('active'));
                chip.classList.add('active');
                selectedBrand = chip.dataset.brand;
                updateModelsList();
            });
        });
    }
    
    // Function to render models and update price
    function updateModelsList() {
        const models = [];
        
        prod.variants.forEach(v => {
            const mVal = v[modelKey];
            if (mVal) {
                let vBrand = 'Diğer';
                if (brandKey && v[brandKey]) {
                    vBrand = v[brandKey];
                } else {
                    vBrand = window.detectBrandFromModel(mVal);
                }
                if (vBrand === selectedBrand && !models.includes(mVal)) {
                    models.push(mVal);
                }
            }
        });
        
        models.sort();
        selectedModel = models[0] || '';
        
        if (modelContainer) {
            if (modelContainer.tagName.toLowerCase() === 'select') {
                modelContainer.innerHTML = models.map(m => {
                    return `<option value="${escapeHTML(m)}">${escapeHTML(m)}</option>`;
                }).join('');
                
                selectedModel = modelContainer.value;

                modelContainer.onchange = (e) => {
                    selectedModel = e.target.value;
                    updatePrice();
                };
            } else {
                modelContainer.innerHTML = models.map((m, idx) => {
                    const isActive = m === selectedModel;
                    return `<div class="quick-buy-chip ${isActive ? 'active' : ''}" data-model="${escapeHTML(m)}">${escapeHTML(m)}</div>`;
                }).join('');

                modelContainer.querySelectorAll('.quick-buy-chip').forEach(chip => {
                    chip.addEventListener('click', (e) => {
                        modelContainer.querySelectorAll('.quick-buy-chip').forEach(c => c.classList.remove('active'));
                        chip.classList.add('active');
                        selectedModel = chip.dataset.model;
                        updatePrice();
                    });
                });
            }
        }
        
        updatePrice();
    }

    function updatePrice() {
        const currentVar = prod.variants.find(v => {
            let matches = true;
            if (v[modelKey] !== selectedModel) matches = false;
            if (brandKey && v[brandKey] !== selectedBrand) matches = false;
            if (!brandKey && window.detectBrandFromModel(v[modelKey]) !== selectedBrand) matches = false;
            return matches;
        }) || prod.variants[0];
        
        if (currentVar) {
            if (priceEl) {
                priceEl.textContent = formatMoney(currentVar.price);
            }
            const comparePriceEl = document.getElementById('quick-buy-compare-price');
            if (comparePriceEl) {
                const actualCompare = currentVar.compare_at_price || 0;
                const compPrice = (actualCompare > currentVar.price) ? actualCompare : Math.ceil(currentVar.price * 1.18);
                if (compPrice > currentVar.price) {
                    comparePriceEl.textContent = formatMoney(compPrice);
                    comparePriceEl.style.display = 'inline';
                } else {
                    comparePriceEl.style.display = 'none';
                }
            }
        }
    }
    
    updateModelsList();
    
    // Submit handler
    if (submitBtn) {
        submitBtn.onclick = () => {
            const variant = prod.variants.find(v => {
                let matches = true;
                if (v[modelKey] !== selectedModel) matches = false;
                if (brandKey && v[brandKey] !== selectedBrand) matches = false;
                if (!brandKey && window.detectBrandFromModel(v[modelKey]) !== selectedBrand) matches = false;
                return matches;
            }) || prod.variants[0];
            
            if (variant) {
                // Personalization data grabbing if present on PDP
                const properties = {};
                const noteInput = document.querySelector('[data-custom-note]');
                if (noteInput && noteInput.value.trim() !== '') {
                    properties['Yazılacak İsim'] = noteInput.value.trim();
                    const activeColorBtn = document.querySelector('.btn-text-color.active');
                    if (activeColorBtn) {
                        const colorCode = activeColorBtn.dataset.color;
                        properties['Yazı Rengi'] = colorCode === '#ffffff' ? 'Beyaz' : 'Siyah';
                    }
                }
                
                window.addToCart(variant.id, 1, properties);
                window.closeQuickBuyModal();
            }
        };
    }
    
    // Show overlay and modal
    overlay.classList.add('active');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
};

window.closeQuickBuyModal = function() {
    const overlay = document.getElementById('quick-buy-overlay');
    const modal = document.getElementById('quick-buy-modal');
    if (overlay) overlay.classList.remove('active');
    if (modal) modal.classList.remove('active');
    document.body.style.overflow = '';
};
